import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "../shared/shared.module";
import { NewDashboardRoutingModule } from "./new-dashboard-routing.module";

import { PerformanceComponent } from "./personnel/performance/performance.component";
import { ProductionComponent } from "./marche/corporate/production/production.component";
import { ProductiviteComponent } from "./marche/corporate/productivite/productivite.component";
import { CorpQosProduitComponent } from "./marche/corporate/qos/corp-qos-produit/corp-qos-produit.component";
import { GlobalProductiviteComponent } from "./global/global-productivite/global-productivite.component";
import { PartProductionComponent } from "./marche/particulier/part-production/part-production.component";
import { ProfProductionComponent } from "./marche/professionnel/prof-production/prof-production.component";
import { DossierComponent as DossierCorporateComponent } from "./marche/corporate/dossier/dossier.component";
import { DepartProductiviteComponent } from "./departement/depart-productivite/depart-productivite.component";
import { JurProductionComponent } from "./direction-juridique/jur-production/jur-production.component";
import { ProductionComponent as ProductionCreditComponent } from "./credit/production/production.component";
import { QualityOfServiceComponent as QualityOfServiceCreditComponent } from "./credit/quality-of-service/quality-of-service.component";
import { DossierComponent as DossierCreditComponent } from "./credit/dossier/dossier.component";
import { JurQosComponent } from "./direction-juridique/jur-qos/jur-qos.component";
import { JurProductiviteComponent } from "./direction-juridique/jur-productivite/jur-productivite.component";
import { PpProductionComponent } from "./marche/product-program/pp-production/pp-production.component";
import { PpProductiviteComponent } from "./marche/product-program/pp-productivite/pp-productivite.component";
import { PpQosComponent } from "./marche/product-program/pp-qos/pp-qos.component";
import { ProfProductiviteComponent } from "./marche/professionnel/prof-productivite/prof-productivite.component";
import { ProfQosComponent } from "./marche/professionnel/prof-qos/prof-qos.component";
import { PartProductiviteComponent } from "./marche/particulier/part-productivite/part-productivite.component";
import { PartQosComponent } from "./marche/particulier/part-qos/part-qos.component";
import { GlobalPortefeuilleComponent } from "./global/global-portefeuille/global-portefeuille.component";
import { TacheByUserComponent } from "./modal/tache-by-user/tache-by-user.component";
import { TacheByWorkflowComponent } from "./modal/tache-by-workflow/tache-by-workflow.component";
import { HistoriqueDossierComponent } from "./modal/historique-dossier/historique-dossier.component";
import { MonPortefeuilleComponent } from "./personnel/mon-portefeuille/mon-portefeuille.component";
import { DossiersCardListComponent } from "./personnel/dossiers-card-list/dossiers-card-list.component";
import { DossiersCardComponent } from "./personnel/dossiers-card-list/dossiers-card/dossiers-card.component";
import { DossiersListComponent } from "./personnel/dossiers-card-list/dossiers-list/dossiers-list.component";
import { DossiersCardListComponent as JuridiqueDossiersCardListComponent } from "./direction-juridique/dossiers-card-list/dossiers-card-list.component";
import { DossiersCardComponent as JuridiqueDossiersCardComponent } from "./direction-juridique/dossiers-card-list/dossiers-card/dossiers-card.component";
import { DossiersListComponent as JuridiqueDossiersListComponent } from "./direction-juridique/dossiers-card-list/dossiers-list/dossiers-list.component";
import { CreditProductiviteComponent } from "./credit/credit-productivite/credit-productivite.component";

import { DossiersCardListComponent as ParticulierDossiersCardListComponent } from "./marche/particulier/dossiers-card-list/dossiers-card-list.component";
import { DossiersCardComponent as ParticulierDossiersCardComponent } from "./marche/particulier/dossiers-card-list/dossiers-card/dossiers-card.component";
import { DossiersListComponent as ParticulierDossiersListComponent } from "./marche/particulier/dossiers-card-list/dossiers-list/dossiers-list.component";

import { DossiersCardListComponent as CorporateDossiersCardListComponent } from "./marche/corporate/dossiers-card-list/dossiers-card-list.component";
import { DossiersCardComponent as CorporateDossiersCardComponent } from "./marche/corporate/dossiers-card-list/dossiers-card/dossiers-card.component";
import { DossiersListComponent as CorporateDossiersListComponent } from "./marche/corporate/dossiers-card-list/dossiers-list/dossiers-list.component";

import { DossiersCardListComponent as ProfessionnelDossiersCardListComponent } from "./marche/professionnel/dossiers-card-list/dossiers-card-list.component";
import { DossiersCardComponent as ProfessionnelDossiersCardComponent } from "./marche/professionnel/dossiers-card-list/dossiers-card/dossiers-card.component";
import { DossiersListComponent as ProfessionnelDossiersListComponent } from "./marche/professionnel/dossiers-card-list/dossiers-list/dossiers-list.component";

import { DossiersCardListComponent as CreditDossiersCardListComponent } from "./credit/dossiers-card-list/dossiers-card-list.component";
import { DossiersCardComponent as CreditDossiersCardComponent } from "./credit/dossiers-card-list/dossiers-card/dossiers-card.component";
import { DossiersListComponent as CreditDossiersListComponent } from "./credit/dossiers-card-list/dossiers-list/dossiers-list.component";
import { SuiviPortefeuilleComponent } from './suivi-portefeuille/suivi-portefeuille.component';
import { PortefeuilleRisqueComponent } from './suivi-portefeuille/portefeuille-risque/portefeuille-risque.component';
import { PreContentieuxComponent } from './suivi-portefeuille/pre-contentieux/pre-contentieux.component';
import { ContentieuxComponent } from './suivi-portefeuille/contentieux/contentieux.component';
import { CreanceRestructureComponent } from './suivi-portefeuille/creance-restructure/creance-restructure.component';
import { DossierRecouvrementComponent } from './suivi-portefeuille/dossier-recouvrement/dossier-recouvrement.component';
import { DossierImpayeComponent } from './suivi-portefeuille/dossier-impaye/dossier-impaye.component';
import { DossierProvisonComponent } from './suivi-portefeuille/dossier-provison/dossier-provison.component';
import { DashboardModule } from '../dashboard/dashboard.module';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

@NgModule({
  imports: [CommonModule, SharedModule, NewDashboardRoutingModule,
    NgxDaterangepickerMd.forRoot()
   // DashboardModule
  ],
  declarations: [
    PerformanceComponent,
    ProductionComponent,
    ProductiviteComponent,
    CorpQosProduitComponent,
    GlobalProductiviteComponent,
    ProductionCreditComponent,
    QualityOfServiceCreditComponent,
    DossierCreditComponent,
    PartProductionComponent,
    ProfProductionComponent,
    DepartProductiviteComponent,
    JurProductionComponent,
    JurQosComponent,
    DossierCorporateComponent,
    JurProductiviteComponent,
    PpProductionComponent,
    PpProductiviteComponent,
    PpQosComponent,
    ProfProductiviteComponent,
    ProfQosComponent,
    PartProductiviteComponent,
    PartQosComponent,
    GlobalPortefeuilleComponent,
    TacheByUserComponent,
    TacheByWorkflowComponent,
    HistoriqueDossierComponent,
    MonPortefeuilleComponent,
    DossiersCardListComponent,
    DossiersCardComponent,
    DossiersListComponent,
    JuridiqueDossiersCardListComponent,
    JuridiqueDossiersCardComponent,
    JuridiqueDossiersListComponent,
    CreditProductiviteComponent,
    ParticulierDossiersCardListComponent,
    ParticulierDossiersCardComponent,
    ParticulierDossiersListComponent,
    CorporateDossiersCardListComponent,
    CorporateDossiersCardComponent,
    CorporateDossiersListComponent,
    ProfessionnelDossiersCardListComponent,
    ProfessionnelDossiersCardComponent,
    ProfessionnelDossiersListComponent,
    CreditDossiersCardListComponent,
    CreditDossiersCardComponent,
    CreditDossiersListComponent,
    SuiviPortefeuilleComponent,
    PortefeuilleRisqueComponent,
    PreContentieuxComponent,
    ContentieuxComponent,
    CreanceRestructureComponent,
    DossierRecouvrementComponent,
    DossierImpayeComponent,
    DossierProvisonComponent
  ],

  providers: [],

  entryComponents: [
    TacheByUserComponent,
    TacheByWorkflowComponent,
    HistoriqueDossierComponent,
  ],
})
export class NewDashboardModule {}
